import React, { useState } from 'react';
import { Shield, Clock, FileText, DollarSign, TrendingUp, Award, Calculator } from 'lucide-react';
export const TradeFinanceHub = () => {
  const [bondValue, setBondValue] = useState(1000000);
  const [selectedProduct, setSelectedProduct] = useState('bid-bond');
  const products = [{
    id: 'bid-bond',
    title: 'Unsecured Bid Bonds',
    turnaround: '1 Hour',
    features: ['No Collateral Required', 'Instant Approval', 'Digital Processing'],
    icon: <Shield size={24} className="text-primary-600" data-id="element-1170" />
  }, {
    id: 'performance-bond',
    title: 'Performance Bonds',
    turnaround: '2 Hours',
    features: ['Tripartite Agreements', 'Reduced Collateral', 'Flexible Terms'],
    icon: <Award size={24} className="text-primary-600" data-id="element-1171" />
  }, {
    id: 'advance-payment',
    title: 'Advance Payment Guarantees',
    turnaround: '3 Hours',
    features: ['Contractor Mobilization', 'Quick Release', 'Competitive Rates'],
    icon: <TrendingUp size={24} className="text-primary-600" data-id="element-1172" />
  }, {
    id: 'cheque-discount',
    title: 'Cheque Discounting',
    turnaround: '30 Minutes',
    features: ['Cash in 30 Minutes', 'Post-dated Cheques', 'Instant Liquidity'],
    icon: <Clock size={24} className="text-primary-600" data-id="element-1173" />
  }, {
    id: 'invoice-discount',
    title: 'Invoice & Certificate Discounting',
    turnaround: '2 Hours',
    features: ['Unlock Working Capital', 'Outstanding Bills', 'Fast Processing'],
    icon: <FileText size={24} className="text-primary-600" data-id="element-1174" />
  }, {
    id: 'lpo-finance',
    title: 'Express LPO Financing',
    turnaround: '4 Hours',
    features: ['Startup Friendly', 'Service Purchase Orders', 'Growth Support'],
    icon: <DollarSign size={24} className="text-primary-600" data-id="element-1175" />
  }];
  const selectedProductData = products.find(p => p.id === selectedProduct);
  return <section id="trade-finance" className="py-20 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white relative overflow-hidden" data-id="element-1176">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-1177">
        <div className="absolute inset-0" style={{
        backgroundImage: 'linear-gradient(30deg, #ffffff 12%, transparent 12.5%, transparent 87%, #ffffff 87.5%, #ffffff), linear-gradient(150deg, #ffffff 12%, transparent 12.5%, transparent 87%, #ffffff 87.5%, #ffffff), linear-gradient(30deg, #ffffff 12%, transparent 12.5%, transparent 87%, #ffffff 87.5%, #ffffff), linear-gradient(150deg, #ffffff 12%, transparent 12.5%, transparent 87%, #ffffff 87.5%, #ffffff)',
        backgroundSize: '80px 140px',
        backgroundPosition: '0 0, 0 0, 40px 70px, 40px 70px'
      }} data-id="element-1178"></div>
      </div>

      <div className="container relative z-10" data-id="element-1179">
        <div className="text-center mb-16" data-id="element-1180">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-5 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-1181">
            <Shield size={18} data-id="element-1182" />
            Enterprise Solutions
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1183">
            Trade Finance Command Center
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed" data-id="element-1184">
            Immediate financial guarantees and bond facilities for businesses.
            Professional-grade solutions with rapid turnaround.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-1185">
          {/* Products Grid */}
          <div className="lg:col-span-2" data-id="element-1186">
            <div className="grid md:grid-cols-2 gap-6" data-id="element-1187">
              {products.map(product => <div key={product.id} onClick={() => setSelectedProduct(product.id)} className={`bg-white/10 backdrop-blur-sm rounded-2xl p-6 border-2 transition-all duration-300 cursor-pointer ${selectedProduct === product.id ? 'border-white shadow-2xl bg-white/20' : 'border-white/20 hover:border-white/40'}`} data-id="element-1188">
                  <div className="flex items-start justify-between mb-4" data-id="element-1189">
                    <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center" data-id="element-1190">
                      {product.icon}
                    </div>
                    <div className="bg-accent-500 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1" data-id="element-1191">
                      <Clock size={12} data-id="element-1192" />
                      {product.turnaround}
                    </div>
                  </div>
                  <h3 className="text-lg font-bold mb-3" data-id="element-1193">{product.title}</h3>
                  <ul className="space-y-2" data-id="element-1194">
                    {product.features.map((feature, idx) => <li key={idx} className="text-sm text-blue-100 flex items-center gap-2" data-id="element-1195">
                        <span className="w-1.5 h-1.5 bg-accent-400 rounded-full" data-id="element-1196"></span>
                        {feature}
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>

          {/* Quick Quote Calculator */}
          <div className="lg:col-span-1" data-id="element-1197">
            <div className="bg-white rounded-2xl p-8 text-gray-900 sticky top-24" data-id="element-1198">
              <div className="flex items-center gap-3 mb-6" data-id="element-1199">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center" data-id="element-1200">
                  <Calculator size={24} className="text-primary-600" data-id="element-1201" />
                </div>
                <h3 className="text-xl font-bold" data-id="element-1202">Quick Quote</h3>
              </div>

              <div className="mb-6" data-id="element-1203">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1204">
                  Product Type
                </label>
                <select value={selectedProduct} onChange={e => setSelectedProduct(e.target.value)} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1205">
                  {products.map(product => <option key={product.id} value={product.id} data-id="element-1206">
                      {product.title}
                    </option>)}
                </select>
              </div>

              <div className="mb-6" data-id="element-1207">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1208">
                  Bond/Financing Value (KSh)
                </label>
                <input type="number" value={bondValue} onChange={e => setBondValue(Number(e.target.value))} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="1,000,000" data-id="element-1209" />
              </div>

              {selectedProductData && <div className="bg-primary-50 rounded-xl p-4 mb-6" data-id="element-1210">
                  <div className="flex items-center justify-between mb-2" data-id="element-1211">
                    <span className="text-sm font-semibold text-gray-700" data-id="element-1212">
                      Estimated Turnaround
                    </span>
                    <span className="text-2xl font-bold text-primary-600" data-id="element-1213">
                      {selectedProductData.turnaround}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1214">
                    <span className="text-sm font-semibold text-gray-700" data-id="element-1215">
                      Amount
                    </span>
                    <span className="text-lg font-bold text-gray-900" data-id="element-1216">
                      KSh {bondValue.toLocaleString()}
                    </span>
                  </div>
                </div>}

              <a href="#apply-now" className="block w-full text-center py-4 px-6 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1217">
                Get Secured Funding Now
              </a>

              <p className="text-xs text-gray-500 text-center mt-4" data-id="element-1218">
                🔒 Secure application • Instant processing
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};